import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopItemsService } from '@/modules/shop/api/services'
import { toast } from 'sonner'
import type { paths } from '@/schema'
import showErrorToast from '@/common/utils/showErrorToast'

type UpdateShopItemBody =
	paths['/api/admin/shop/items/{id}']['patch']['requestBody']['content']['application/json']
type UpdateShopItemResponse =
	paths['/api/admin/shop/items/{id}']['patch']['responses']['200']['content']['application/json']

const useMutationUpdateShopItem = () => {
	const queryClient = useQueryClient()

	return useMutation<
		UpdateShopItemResponse,
		Error,
		{ id: string; data: UpdateShopItemBody }
	>({
		mutationFn: ({ id, data }) => ShopItemsService.updateShopItem(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SHOP_QUERY_KEYS.ITEMS.ALL })
			toast.success('อัปเดตสินค้าสำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})
}

export default useMutationUpdateShopItem
